export default __webpack_public_path__ + "static/media/colored-offer-unpublish-icon.5240b2af.svg";